import styled from 'styled-components';
import { SIZE } from './common/sizes';

interface MainAppContainerProps {
    blurBackgroud?: boolean;
}

export const MainAppContainer = styled.div`
    display: flex;
    overflow:hidden;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    min-width: 900px;
    height: 100vh;
    width: 100vw;
    flex-flow: row;
    filter: ${(props: MainAppContainerProps) => props.blurBackgroud ? "blur(0px)" : "blur(0px)"};
    -webkit-filter: ${(props: MainAppContainerProps) => props.blurBackgroud ? "blur(0px)" : "blur(0px)"};
`
